import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import { EUI_THEME_BOREALIS_KEY, EuiThemeBorealis } from '@elastic/eui-theme-borealis';
import { AMSTERDAM_NAME_KEY, EuiThemeAmsterdam } from '../../../../src/themes';
// @ts-ignore importing from a JS file
import { applyTheme, registerTheme } from '../../services';
// @ts-ignore Sass
import amsterdamThemeLight from '../../theme_amsterdam_light.scss';
// @ts-ignore Sass
import amsterdamThemeDark from '../../theme_amsterdam_dark.scss';

// @ts-ignore Sass
import borealisThemeLight from '../../theme_borealis_light.scss';
// @ts-ignore Sass
import borealisThemeDark from '../../theme_borealis_dark.scss';
var THEME_CSS_MAP = _defineProperty(_defineProperty({}, AMSTERDAM_NAME_KEY, {
  LIGHT: amsterdamThemeLight,
  DARK: amsterdamThemeDark
}), EUI_THEME_BOREALIS_KEY, {
  LIGHT: borealisThemeLight,
  DARK: borealisThemeDark
});
export var AVAILABLE_THEMES = [{
  text: 'Borealis',
  value: EuiThemeBorealis.key,
  provider: EuiThemeBorealis
}, {
  text: 'Amsterdam',
  value: AMSTERDAM_NAME_KEY,
  provider: EuiThemeAmsterdam
}];
var THEME_NAMES = AVAILABLE_THEMES.map(function (_ref) {
  var value = _ref.value;
  return value;
});
AVAILABLE_THEMES.forEach(function (theme) {
  registerTheme(theme.value, THEME_CSS_MAP[theme.value]);
});
export var ThemeContext = /*#__PURE__*/React.createContext({
  theme: undefined,
  colorMode: undefined,
  highContrastMode: undefined,
  themeLanguage: 'language--js',
  i18n: 'en',
  setContext: function setContext() {}
});
var localStorageKeyToStateMap = {
  themeName: 'theme',
  colorMode: 'colorMode',
  highContrastMode: 'highContrastMode',
  i18n: 'i18n',
  themeLanguage: 'themeLanguage'
};
export class ThemeProvider extends React.Component {
  constructor(props) {
    super(props);
    const theme = localStorage.getItem('themeName') || THEME_NAMES[0];
    const colorMode = localStorage.getItem('colorMode') || undefined;
    const highContrastMode = localStorage.getItem('highContrastMode') ? localStorage.getItem('highContrastMode') === 'true' : undefined;
    const i18n = localStorage.getItem('i18n') || 'en';
    applyTheme(theme && THEME_NAMES.includes(theme) ? theme : THEME_NAMES[0], colorMode);
    const themeLanguage = this.getThemeLanguage();
    this.state = {
      theme,
      colorMode,
      highContrastMode,
      i18n,
      themeLanguage
    };
    Object.keys(localStorageKeyToStateMap).forEach(key => this.updateLocalStorage(key, this.state));
  }
  setContext = state => {
    this.setState(prevState => {
      return {
        ...prevState,
        ...state
      };
    });
  };
  updateLocalStorage = (key, state) => {
    if (state[localStorageKeyToStateMap[key]] !== undefined) {
      localStorage.setItem(key, String(state[localStorageKeyToStateMap[key]]));
    }
  };
  componentDidUpdate(_prevProps, prevState) {
    Object.keys(localStorageKeyToStateMap).forEach(key => {
      const _key = key;
      const stateKey = localStorageKeyToStateMap[_key];
      if (prevState[stateKey] !== this.state[stateKey] || localStorage.getItem(_key) === null) {
        this.updateLocalStorage(_key, this.state);

        // Side effects
        if (_key === 'themeName' || _key === 'colorMode') {
          applyTheme(this.state.theme, this.state.colorMode);
        }
        if (_key === 'themeLanguage') {
          this.setThemeLanguageParam(this.state.themeLanguage);
        }
      }
    });
  }
  getThemeLanguage = () => {
    // Allow theme language to be set by URL param, so we can link people
    // to specific docs, e.g. ?themeLanguage=js, ?themeLanguage=sass
    // Note that because of our hash router, this logic only works on page load/full reload
    const urlParams = window?.location?.href?.split('?')[1]; // Note: we can't use location.search because of our hash router
    const fromUrlParam = new URLSearchParams(urlParams).get('themeLanguage');
    // Otherwise, obtain it from localStorage
    const fromLocalStorage = localStorage.getItem('themeLanguage');
    const themeLanguage = fromUrlParam ? `language--${fromUrlParam}` : fromLocalStorage;

    // If not set by either param or storage, or an invalid value, use the default
    return themeLanguage || 'language--js';
  };
  setThemeLanguageParam = languageKey => {
    const languageValue = languageKey.replace('language--', ''); // Make our params more succinct
    const hash = window?.location?.hash?.split('?'); // Note: we can't use location.search because of our hash router

    const queryParams = hash[1];
    const params = new URLSearchParams(queryParams);
    params.set('themeLanguage', languageValue);
    window.location.hash = `${hash[0]}?${params.toString()}`;
  };
  render() {
    const {
      children
    } = this.props;
    const {
      theme,
      colorMode,
      highContrastMode,
      i18n,
      themeLanguage
    } = this.state;
    return <ThemeContext.Provider value={{
      theme,
      colorMode,
      highContrastMode,
      i18n,
      themeLanguage,
      setContext: this.setContext
    }}>
        {children}
      </ThemeContext.Provider>;
  }
}